import { Checkbox, InputAdornment, TextField, Tooltip } from "@mui/material";
import { useState } from "react";

interface TextFieldWithCheckboxDEProps {
  checkboxValue?: boolean;
  textFieldValue: number | null;
  textFieldLabel?: string;
  checkboxLabel?: string;
  disabledTextField?: boolean;
  disabledCheckbox?: boolean;
  onChangeCheckbox?: (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean,
  ) => Promise<void> | void;
  onChangeTextField?: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => void;
  onBlur?: () => void;
  onFocus?: () => void;
}

export const TextFieldWithCheckboxDE = ({
  checkboxValue,
  textFieldValue,
  textFieldLabel,
  checkboxLabel,
  disabledTextField = true,
  disabledCheckbox = false,
  onChangeCheckbox = () => {},
  onChangeTextField = () => {},
  onBlur = () => {},
  onFocus = () => {},
}: TextFieldWithCheckboxDEProps) => {
  const [isDisabled, setIsDisabled] = useState(false);

  const handleCheckboxChange = async (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    if (isDisabled) return;
    setIsDisabled(true);

    try {
      await onChangeCheckbox(e, e.target.checked);
    } finally {
      setIsDisabled(false);
    }
  };

  return (
    <TextField
      label={textFieldLabel}
      value={textFieldValue || ""}
      onChange={onChangeTextField}
      variant="outlined"
      fullWidth
      margin="dense"
      autoComplete="off"
      onFocus={onFocus}
      disabled={disabledTextField}
      onBlur={onBlur}
      slotProps={{
        input: {
          endAdornment: (
            <InputAdornment position="end" sx={{ margin: 0 }}>
              <Tooltip title={checkboxLabel || ""} arrow placement="right">
                <span>
                  {" "}
                  {/* Tooltip needs a child element to attach to */}
                  <Checkbox
                    color="primary"
                    size="small"
                    disabled={disabledCheckbox || isDisabled}
                    sx={{ padding: "0 2 2", margin: 0 }}
                    checked={!!checkboxValue}
                    onChange={handleCheckboxChange}
                  />
                </span>
              </Tooltip>
            </InputAdornment>
          ),
        },
      }}
    />
  );
};
